import { DataGrid } from "@mui/x-data-grid"
import { Paper, Stack, TextField } from "@mui/material"
import { useMemo, useState } from "react"
import { useSearchDsUserIdsQuery } from "../../core/api/ds-user-api"

const columns = [
    {
        field: "id",
        headerName: "Index",
        width: 50
    },
    {
        field: "userId",
        headerName: "User ID",
        flex: 1
    }
]

const AnalyticalSearchDS = () => {
    const [sTransactionId, setSTransactionId] = useState("")

    const {
        data,
        isLoading,
        isFetching
    } = useSearchDsUserIdsQuery({
        "sTransactionId": sTransactionId
    }, {
        skip: !sTransactionId || sTransactionId.trim() === ""
    })

    const rows = useMemo(() => {
        return data?.map((userId, index) => ({ id: index, userId: userId })) ?? []
    }, [data])

    return (
        <Stack spacing={2} direction="column">
            <Paper sx={{ p: 2 }}>
                <TextField
                    size="small"
                    label="S Transaction ID"
                    value={sTransactionId}
                    onChange={e => setSTransactionId(e.target.value.trim())}
                />
            </Paper>
            <DataGrid
                hideFooter
                loading={isLoading || isFetching}
                columns={columns}
                rows={rows}
            />
        </Stack>
    )
}

export default AnalyticalSearchDS
